import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Field } from '../../model/formBuilderInterface';
import { DEFAULT_TEXT_AREA_CHARS_LIMIT } from '../../../../constants/constant';
import { LABELS, REPLACE_KEY } from '../../constants/constant';
import { ValidationErrorsComponent } from '../validation-errors/validation-errors.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-textarea',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ValidationErrorsComponent]
})
export class FormTextAreaComponent {
  @Input() field: Field;
  @Input() form: FormGroup;
  labels = LABELS;
  @ViewChild('textArea') textArea: ElementRef<HTMLTextAreaElement>;
  isTextAreaFocused = false;
  cursorPosition: number = 0;
  private preventBlur: boolean = false;

  trimInputValue() {
    const control = this.form.get(this.field.name);
    if (control && control.value) {
      const value = control.value;
      control.setValue(value.trim());
    }
  }
  get maxLength(): number {
    return this.field.maxlength || DEFAULT_TEXT_AREA_CHARS_LIMIT;
  }
  get characterCountText(): string {
    const charCount = this.form.get(this.field.name)?.value?.length || 0;
    return `${this.maxLength - charCount} ${LABELS.CHARACTERS_LEFT}`;
  }

  insertFirstName(event: MouseEvent) {
    event.preventDefault();
    const textAreaElement = this.textArea?.nativeElement;
    if (textAreaElement) {
      const replaceVal = REPLACE_KEY.FIRST_NAME;
      const replaceValWithSpace = `${replaceVal} `;
      const replaceValLength = replaceValWithSpace.length;
      const formControl = this.form.get(this.field.name);
      const currentText = formControl.value || '';
      const cursorPosition = textAreaElement.selectionStart;

      if (this.isTextAreaFocused) {
        // If the text area is focused, insert at the cursor position
        const textBeforeCursor = currentText.substring(0, cursorPosition);
        const textAfterCursor = currentText.substring(cursorPosition);
        const updatedText = `${textBeforeCursor}${replaceValWithSpace}${textAfterCursor}`;
        formControl.setValue(updatedText);

        // Set the cursor position after the inserted text
        setTimeout(() => {
          this.cursorPosition += replaceValLength;
          textAreaElement.selectionStart = textAreaElement.selectionEnd =
            cursorPosition + replaceValLength;
          textAreaElement.focus();
        }, 0);
      } else {
        // If the text area is not focused, append at the end
        const updatedText = `${currentText}${replaceValWithSpace}`;
        formControl.setValue(updatedText);
        setTimeout(() => {
          this.cursorPosition = updatedText.length;
        }, 0);
      }
    }
    setTimeout(() => (this.preventBlur = false), 0);
  }
  onButtonMouseDown(event: MouseEvent) {
    this.preventBlur = true;
    event.preventDefault();
  }
  onFocus() {
    this.isTextAreaFocused = true;
    const textAreaElement = this.textArea?.nativeElement;
    this.cursorPosition = textAreaElement?.selectionStart || 0;
  }
  onBlur() {
    if (this.preventBlur) {
      return;
    }
    this.isTextAreaFocused = false;
    const textAreaElement = this.textArea?.nativeElement;
    this.cursorPosition = textAreaElement?.selectionStart || 0;
    this.trimInputValue();
  }
}
